const headCells = [
	{ id: 1, property: 'firstName', label: 'First name' },
	{ id: 2, property: 'lastName', label: 'Last name' },
	{ id: 3, property: 'phone', label: 'Work phone' },
	{ id: 4, property: 'email', label: 'Work Email' },
	{ id: 5, property: 'type', label: 'Is User' },
];

export default headCells;
